/**
 * WCAG 2.x kontrast — zaklad AA fail-fast verifieru theme compileru.
 * Vzor Style Library: temata se nekompiluji, pokud nektery definovany
 * par barev nesplni AA (4.5:1 text, 3:1 velky text / UI komponenty).
 */
function channel(v) {
    const s = v / 255;
    return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}
function parseHex(hex) {
    const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
    if (!m || !m[1])
        throw new Error(`Neplatna hex barva: "${hex}" (ocekavam #rgb nebo #rrggbb)`);
    const h = m[1].length === 3 ? [...m[1]].map((c) => c + c).join('') : m[1];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
/** Relativni luminance dle WCAG. */
export function relativeLuminance(hex) {
    const [r, g, b] = parseHex(hex);
    return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
}
/** Kontrastni pomer 1..21 (symetricky). */
export function contrastRatio(a, b) {
    const la = relativeLuminance(a);
    const lb = relativeLuminance(b);
    const [hi, lo] = la >= lb ? [la, lb] : [lb, la];
    return (hi + 0.05) / (lo + 0.05);
}
/**
 * Fail-fast AA kontrola: prvni nevyhovujici par hodi chybu se jmenem paru
 * a namerenym pomerem. Default minimum 4.5 (bezny text).
 */
export function assertAA(pairs) {
    for (const [fg, bg, label, min = 4.5] of pairs) {
        const ratio = contrastRatio(fg, bg);
        if (ratio < min) {
            throw new Error(`AA kontrast selhal pro par "${label}": ${fg} na ${bg} = ${ratio.toFixed(2)}:1, minimum ${min.toFixed(1)}:1 (AA 4.5:1 text / 3:1 UI)`);
        }
    }
}
//# sourceMappingURL=contrast.js.map